import styled, { keyframes } from 'styled-components';
import { ifProp } from 'styled-tools';

const COLORS = {
  white: '#ffffff',
  overlayDark: '#33333322',
  panelShadow: '#0000004D',
  lightGrey: '#616161',
  primaryGreen: '#009688',
};

const Wrapper = styled.div`
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 201;
`;

const overlayAnimationIn = keyframes`
  0% { 
    backdrop-filter: blur(0);
    opacity: 0;
  }
  100% { 
    backdrop-filter: blur(3px);
    opacity: 1;
  }
`;

const overlayAnimationOut = keyframes`
  0% { 
    backdrop-filter: blur(3px);
    opacity: 1;
  }
  100% { 
    backdrop-filter: blur(0);
    opacity: 0;
  }
`;

const Overlay = styled.div`
  animation: ${ifProp(
      { state: 'opened' },
      overlayAnimationIn,
      overlayAnimationOut
    )}
    0.7s 0s forwards;
  background-color: ${COLORS.overlayDark};
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: -1;
`;

const panelAnimationIn = keyframes`
  0% { height: 0px }
  100% { height: 660px }
`;

const panelAnimationOut = keyframes`
  0% { height: 660px }
  100% { height: 0px }
`;

const Panel = styled.div`
  animation: ${ifProp({ state: 'opened' }, panelAnimationIn, panelAnimationOut)}
    0.7s 0s forwards;
  background-color: ${COLORS.white};
  box-shadow: 0px 3px 30px ${COLORS.panelShadow};
  overflow: hidden;
  position: relative;
  width: 100%;
  z-index: 1;
  display: flex;

  @media (max-width: 1280px) {
    flex-direction: column;
    overflow-y: auto;
  }
`;

const CloseButton = styled.div`
  cursor: pointer;
  height: 26px;
  position: absolute;
  right: 101px;
  top: 40px;
  width: 26px;

  &:hover {
    &:before,
    &:after {
      background-color: ${COLORS.primaryGreen};
    }
  }

  &:after,
  &:before {
    background-color: ${COLORS.lightGrey};
    content: '';
    display: inline-block;
    height: 2px;
    left: 0;
    position: absolute;
    transform: rotate(-45deg);
    top: 11px;
    width: 100%;
  }

  &:after {
    transform: rotate(45deg);
  }

  @media (max-width: 1280px) {
    right: 30px;
  }
`;

const SavedAddressesWraper = styled.div`
  margin-left: 95px;
  margin-top: 100px;
  max-width: 400px;

  @media (max-width: 1280px) {
    margin-left: 30px;
    margin-right: 30px;
  }
`;

const BillingAddressWrapper = styled.div`
  position: relative;
  width: auto;
  max-width: 800px;
  margin-left: 100px;

  > div {
    position: relative !important;
    left: 0;
    padding-bottom: 50px;
    margin-right: 30px;
  }

  @media (max-width: 1280px) {
    margin-left: 30px;
  }
`;

export {
  Wrapper,
  Overlay,
  Panel,
  CloseButton,
  SavedAddressesWraper,
  BillingAddressWrapper,
};
